import {Component, OnDestroy, OnInit} from '@angular/core';
import {Subscription} from 'rxjs/Subscription';
import {TrackingService} from '../services/tracking.service';
import {TourService} from '../services/tour.service';
import {ModalService} from '../services/modal.service';
import {TourApiService} from '../services/tour-api.service';
import {ActivatedRoute, NavigationExtras, Router} from '@angular/router';
import {TourTag, TourTagType} from '../model/tour-tag';
import {OptionGroup} from '../model/option-group';
import {Tour} from '../model/tour';
import {OptionDetailService} from '../services/option-detail.service';

@Component({
  selector: 'gt-tag',
  templateUrl: './tag.component.html',
  styleUrls: ['./tag.component.css']
})
export class TagComponent implements OnInit, OnDestroy {

  private paramsSubscription: Subscription;
  private tourLoadedSubscription: Subscription;
  tagLoaded = false;
  constructor(public apiService: TourApiService,
              private router: Router,
              private route: ActivatedRoute,
              private tourService: TourService,
              private trackingService: TrackingService,
              public modalService: ModalService,
              public optionDetailService: OptionDetailService) { }

  ngOnInit() {

    this.tourLoadedSubscription = this.apiService.tourLoaded.subscribe(
      (loaded: boolean) => {
        if (loaded) {
          // no need to keep monitoring the route params
          this.trackingService.configurePiwik(this.apiService.builderPath, this.apiService.modelPath);
          this.trackingService.trackAction(TrackingService.kActionMain, 'Load', 0);
          // default to the 'tour/video' path unless a redirectUrl parameter was on the incoming request
          // or... if the tour is web360 only, redirect to the /3d path

          const routes = this.apiService.tourRoutesForContent();
          this.router.navigate(routes, {replaceUrl: true});
        }
      }
    );

    this.paramsSubscription = this.route.params.subscribe(
      (params: any) => {

        if (params['builder'] != null && params['model'] != null) {

          this.tourService.tourTag = new TourTag(this.router.url, params);
          this.apiService.builderPath = this.tourService.tourTag.builderPath;
          this.apiService.modelPath = this.tourService.tourTag.modelPath;

          this.apiService.fetchMainTourInfo().subscribe(
            data => {
              this.tourService.tour = new Tour(data['results']);

              switch (this.tourService.tourTag.type) {

                case TourTagType.Video: {
                  this.tagLoaded = true;
                  this.modalService.showModalVideo(this.tourService.tourTag.video, '');
                }
                  break;

                case TourTagType.Option: {
                  for (const scene of this.tourService.tour.sceneList) {
                    if (scene.id === this.tourService.tourTag.sceneID) {

                      this.apiService.fetchOptionsForScene(scene).subscribe(
                        sceneData => {
                          // some scenes may not have any options groups or options
                          const optionGroupsListJSON: any[] = sceneData['results']['scene']['optionGroups'];
                          for (const key in Object.keys(optionGroupsListJSON)) {
                            if (optionGroupsListJSON.hasOwnProperty(key)) {
                              scene.optionGroups.push(new OptionGroup(optionGroupsListJSON[key], scene.id));
                            }
                          }

                          this.tagLoaded = true;
                          // find the option
                          for (const group of scene.optionGroups) {
                            for (const option of group.options) {
                              if (option.id === this.tourService.tourTag.optionID) {
                                this.optionDetailService.showOption(option);
                                break;
                              }
                            }
                          }
                        },
                        error => {
                          console.log(error);
                        }
                      );
                    }
                  }
                }
                  break;

                case TourTagType.Scene:
                case TourTagType.Tour: {
                  this.apiService.fetchTourInfoForBuilderAndModel(this.tourService.tourTag.builderPath,
                                                                  this.tourService.tourTag.modelPath);
                }
                  break;

              }
            });
        }
    });
  }

  showTourForTag() {
    this.router.navigate([this.tourService.tourTag.builderPath,
                          this.tourService.tourTag.modelPath], {replaceUrl: true});
  }

  ngOnDestroy() {
    this.paramsSubscription.unsubscribe();
    this.tourLoadedSubscription.unsubscribe();
  }
}

/*

http://localhost:4200/veridian/maybeck/direct/
http://localhost:4200/veridian/maybeck/direct/scene/15/
http://localhost:4200/veridian/maybeck/direct/scene/15/option/628/
http://localhost:4200/veridian/maybeck/direct/video/ads/portrait/kevin-high.mp4/

http://192.168.155.112:8080/veridian/maybeck/direct/
http://192.168.155.112:8080/veridian/maybeck/direct/scene/15/
http://192.168.155.112:8080/veridian/maybeck/direct/scene/15/option/628/
http://192.168.155.112:8080/veridian/maybeck/direct/video/ads/portrait/kevin-high.mp4/

 */



// WEBPACK FOOTER //
// ./src/app/components/tag.component.ts